
import { Component, Vue, Prop, Watch, Emit, Ref } from 'vue-property-decorator'
import Tabs from './Tabs.vue'
import Content from './Content.vue'
import { stationeryGroupName } from '@xt/client/dataSource/stationery/index'

@Component({
  components: {
    Tabs,
    Content
  }
})
export default class CategoryPanel extends Vue {
  active: number = 0
  scrollTop: number = 895 + 16

  get tabList() {
    return stationeryGroupName
  }

  @Emit('show-qrcode-pop')
  handleShowQrcode(item) {
    return item
  }

  // 切换tab
  handleChange(index: number) {
    if (this.active === index) return

    this.active = index

    // 切换的时候自动顶上来
    window.scrollTo({
      top: this.scrollTop,
      behavior: 'smooth'
    })
  }

  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
